import { KOV } from '../types';
export default {
  type: KOV,
  service: 'etherscan.io',
  url: 'https://kovan.etherscan.io/api',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
